/* eslint-disable react/prop-types */

import { Box, Button, Card, Chip, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";

export default function BusinessCard({ item, selectedBusiness, getLat, getLong, onSelect }) {
    const lat = getLat(item);
    const long = getLong(item);

    const hasLocation =
        lat !== null &&
        lat !== undefined &&
        lat !== "" &&
        long !== null &&
        long !== undefined &&
        long !== "";

    const isSelected = selectedBusiness?.id === item.id;

    return (
        <Card
            sx={{
                height: "100%",
                borderRadius: 4,
                p: 2.3,
                position: "relative",
                overflow: "hidden",
                border: "1px solid",
                borderColor: isSelected
                    ? alpha("#16a34a", 0.42)
                    : "rgba(226, 232, 240, 0.95)",
                bgcolor: isSelected ? alpha("#16a34a", 0.035) : "#fff",
                boxShadow: isSelected
                    ? "0 18px 34px rgba(22,163,74,0.12)"
                    : "0 12px 28px rgba(15,23,42,0.045)",
                transition: "all .22s ease",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 18px 42px rgba(15,23,42,0.09)",
                    borderColor: isSelected
                        ? alpha("#16a34a", 0.5)
                        : alpha("#0284c7", 0.38),
                },
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    left: 0,
                    height: 4,
                    bgcolor: isSelected ? "#16a34a" : "#0284c7",
                }}
            />

            <Stack spacing={2.1}>
                <Stack direction="row" spacing={1.35} alignItems="center">
                    <Box
                        sx={{
                            width: 50,
                            height: 50,
                            borderRadius: 3,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: isSelected ? alpha("#16a34a", 0.12) : alpha("#0284c7", 0.09),
                            color: isSelected ? "#15803d" : "#0284c7",
                            flexShrink: 0,
                        }}
                    >
                        <StorefrontRoundedIcon />
                    </Box>

                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography
                            fontWeight={950}
                            sx={{
                                fontSize: 16,
                                color: "#0f172a",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {item.name}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                mt: 0.35,
                                color: "#64748b",
                                fontWeight: 650,
                                fontSize: 12,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {item.address || "آدرس ثبت نشده"}
                        </Typography>
                    </Box>
                </Stack>

                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    {isSelected && (
                        <Chip
                            size="small"
                            label="انتخاب شده"
                            sx={{
                                bgcolor: alpha("#16a34a", 0.13),
                                color: "#15803d",
                                fontWeight: 950,
                            }}
                        />
                    )}
                </Stack>

                <Button
                    fullWidth
                    disabled={!hasLocation}
                    onClick={() => onSelect(item)}
                    sx={{
                        height: 43,
                        borderRadius: 3,
                        fontWeight: 950,
                        color: isSelected ? "#fff" : "#0284c7",
                        border: "1px solid",
                        borderColor: isSelected ? "#16a34a" : alpha("#0284c7", 0.45),
                        backgroundColor: isSelected ? "#16a34a" : "#fff",
                        boxShadow: isSelected
                            ? "0 10px 22px rgba(22,163,74,0.2)"
                            : "none",
                        "&:hover": {
                            color: isSelected ? "#fff" : "#0369a1",
                            borderColor: isSelected ? "#15803d" : "#0284c7",
                            backgroundColor: isSelected
                                ? "#15803d"
                                : alpha("#0284c7", 0.06),
                        },
                        "&.Mui-disabled": {
                            color: "#94a3b8",
                            borderColor: "rgba(148,163,184,0.35)",
                            backgroundColor: "rgba(148,163,184,0.07)",
                        },
                    }}
                >
                    {isSelected ? "انتخاب شده" : "انتخاب و دریافت گزارش"}
                </Button>
            </Stack>
        </Card>
    );
}
